import useAxiosRequest from '@/axios/index'

let axiosRequestInstance: ReturnType<typeof useAxiosRequest> | null = null

export default function useRequest() {
  if (!axiosRequestInstance) {
    axiosRequestInstance = useAxiosRequest()
  }
  return axiosRequestInstance
}
